import storeEvent from '../../utils/store-event';
import defaultErrorMessages from '../../utils/default-error-message';
import { ajax } from '../../utils/ajax-handler';
import { getTabIdx } from '../../utils/tab-helpers';

export default class {
    onMount() {
        this.initialProfilePayload = {};
        this.aboutTabIdx = getTabIdx('about');
        this.subscribeTo(document).on('presenceEdit', this.editReducer.bind(this));
    }
    setInitialProfilePayload({ field, value }) {
        if (!this.initialProfilePayload.hasOwnProperty(field)) {
            this.initialProfilePayload[field] = value;
        }
    }
    editReducer(event) {
        const { action: { name }, payload } = event.detail;
        switch (name) {
            case 'EDIT_EBAY_USER_PROFILE': {
                this.emit('set', {
                    key: 'editing',
                    value: true
                });
                storeEvent.changeToTab.dispatch({
                    tabIndex: this.aboutTabIdx,
                    skipFocus: true
                });
                break;
            }
            case 'CANCEL_EDIT_EBAY_USER_PROFILE': {
                this.emit('set', {
                    key: 'editing',
                    value: false
                });
                this.emit('set', {
                    key: 'payload',
                    value: this.initialProfilePayload
                });
                break;
            }
            case 'SAVE_EBAY_USER_PROFILE':
            case 'SAVE_PROFILE_AND_GO_CHANGE_USERNAME': {
                this.emit('set', {
                    key: 'saveError',
                    value: null
                });
                if (name === 'SAVE_PROFILE_AND_GO_CHANGE_USERNAME') {
                    this.emit('set', {
                        key: 'saveAndGo',
                        value: true
                    });
                } else {
                    this.emit('set', {
                        key: 'saving',
                        value: true
                    });
                }
                this.saveProfile()
                    .then(() => {
                        this.emit('set', {
                            key: 'editing',
                            value: false
                        });
                        this.initialProfilePayload = Object.assign(
                            { userLogoUrl: '', aboutDescription: '' },
                            this.input.globalState.profileEdit.payload
                        );
                    })
                    .catch((response) => {
                        this.emit('set', {
                            key: 'saveError',
                            value: response
                        });
                    })
                    .then(() => {
                        this.emit('set', {
                            key: 'saving',
                            value: false
                        });
                        this.emit('set', {
                            key: 'saveAndGo',
                            value: false
                        });
                    });
                break;
            }
            case 'UPDATE_PROFILE_FIELD': {
                this.setInitialProfilePayload(payload);
                this.emit('set', {
                    key: 'payload',
                    partial: true,
                    value: {
                        [payload.field]: payload.value
                    }
                });
                this.emit('set', {
                    key: 'saveError',
                    value: null
                });
                break;
            }
            case 'SET_SAVE_EDIT_ERROR': {
                this.emit('set', {
                    key: 'saveError',
                    value: payload
                });
                break;
            }
            default: {
                console.warn('Unexpected action name for profile edit', event.detail);
            }
        }
    }
    async saveProfile() {
        return new Promise((resolve, reject) => {
            const link = document.createElement('a');
            link.href = window.location.href;
            const request = {
                url: link.pathname,
                method: 'POST',
                body: Object.assign(
                    { userLogoUrl: '', aboutDescription: '' },
                    this.input.globalState.profileEdit.payload
                )
            };
            ajax(request, {
                successCallBack: () => {
                    resolve();
                },
                errorCallBack: (response) => {
                    if (response.modules) {
                        reject(response);
                    } else {
                        reject({
                            modules: {
                                STATUS_MESSAGE_INLINE_MODULE: defaultErrorMessages['en-US']
                            }
                        });
                    }
                }
            },
            10000);
        });
    }
}
